<mui-modal-header [title]="title" [titleId]="titleId" [hideCloseButton]="!closeButton"></mui-modal-header>
<mui-modal-body>
  <p class="message" *ngIf="message">{{ message }}</p>
  <ng-container *ngIf="content" [ngTemplateOutlet]="content" [ngTemplateOutletContext]="{ $implicit: modal }"></ng-container>
</mui-modal-body>
<mui-modal-footer>
  <button
    *ngIf="dismissButton"
    mui-btn
    class="dismiss-button"
    [appearance]="dismissButtonConfig.appearance"
    (click)="modal.dismiss(dismissButtonConfig.returnValue)">
    {{ dismissButtonConfig?.label }}
  </button>
  <button
    mui-btn
    #confirmBtn
    class="confirm-button"
    [appearance]="confirmButtonConfig.appearance"
    (click)="modal.close(confirmButtonConfig.returnValue)"
  >
    {{ confirmButtonConfig?.label }}
  </button>
</mui-modal-footer>
